import React from "react";
import { graphTypes } from "../graphView/graphTypeOptions";
import ChartFullscreenShell from "./ChartFullscreenShell";
import { isPondDetailGraphType } from "../pondStat/wqChartConfigs";
import PondDetailGraphChart from "./charts/PondDetailGraphChart";
import {
  AvgWrVsDateChart,
  NumberFrequencyChart,
  NumberFrequencyVsBinByDateChart,
  NumberFrequencyVsBinChart,
  StandardVsActualChart,
  TaggedWrVsDateChart,
  WeightVsLengthByDateChart,
  WeightVsLengthChart,
  WrVsLengthChart,
} from "./charts";

const REGISTRY = {
  "wr-vs-length": WrVsLengthChart,
  "weight-vs-length": WeightVsLengthChart,
  "weight-vs-length-by-date": WeightVsLengthByDateChart,
  "avg-wr-vs-date": AvgWrVsDateChart,
  "tagged-wr-vs-date": TaggedWrVsDateChart,
  "standard-vs-actual": StandardVsActualChart,
  "number-frequency": NumberFrequencyChart,
  "number-frequency-vs-bin": NumberFrequencyVsBinChart,
  "number-frequency-vs-bin-by-date": NumberFrequencyVsBinByDateChart,
};

export default function GraphChartV2({
  selectedGraphType,
  graphData,
  pondDetails,
  selectedUnit,
  selectedFish,
  isMobile,
  hoveredWeightPoint,
  setHoveredWeightPoint,
  selectedBinSize,
  focusDetailId,
  precomputedPsdRows,
}) {
  const title =
    graphTypes.find((t) => t.id === selectedGraphType)?.name ?? "Graph";

  if (isPondDetailGraphType(selectedGraphType)) {
    if (
      !pondDetails?.length &&
      !(selectedGraphType === "psd-vs-date" && precomputedPsdRows?.length)
    ) {
      return null;
    }
    return (
      <ChartFullscreenShell title={title} hideExternalToolbar>
        <PondDetailGraphChart
          chartId={selectedGraphType}
          pondDetails={pondDetails}
          selectedFish={selectedFish}
          selectedUnit={selectedUnit}
          selectedBinSize={selectedBinSize}
          isMobile={isMobile}
          focusDetailId={focusDetailId}
          precomputedPsdRows={precomputedPsdRows}
        />
      </ChartFullscreenShell>
    );
  }

  if (!graphData.length) return null;
  const C = REGISTRY[selectedGraphType];
  if (!C) return null;

  let inner = null;

  if (
    selectedGraphType === "weight-vs-length" ||
    selectedGraphType === "weight-vs-length-by-date"
  ) {
    inner = (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        selectedFish={selectedFish}
        isMobile={isMobile}
        hoveredWeightPoint={hoveredWeightPoint}
        setHoveredWeightPoint={setHoveredWeightPoint}
      />
    );
  } else if (
    selectedGraphType === "number-frequency-vs-bin" ||
    selectedGraphType === "number-frequency-vs-bin-by-date"
  ) {
    inner = (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        isMobile={isMobile}
        selectedBinSize={selectedBinSize}
      />
    );
  } else if (selectedGraphType === "avg-wr-vs-date" || selectedGraphType === "tagged-wr-vs-date") {
    inner = <C graphData={graphData} isMobile={isMobile} />;
  } else if (selectedGraphType === "number-frequency") {
    inner = (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        isMobile={isMobile}
        selectedBinSize={selectedBinSize}
      />
    );
  } else {
    inner = (
      <C
        graphData={graphData}
        selectedUnit={selectedUnit}
        selectedFish={selectedFish}
        isMobile={isMobile}
      />
    );
  }

  return (
    <ChartFullscreenShell title={title} hideExternalToolbar>
      {inner}
    </ChartFullscreenShell>
  );
}
